var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeaderSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconHeaderSearch",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.1795L10.9474 12.2564C11.9579 11.1897 12.5474 9.71282 12.5474 8.15385C12.6316 4.78974 9.76842 2 6.31579 2C2.86316 2 0 4.78974 0 8.15385C0 11.5179 2.77895 14.3077 6.31579 14.3077C7.74737 14.3077 9.01053 13.8154 10.1053 13.0769L15.1579 18L16 17.1795ZM1.26316 8.15385C1.26316 5.44615 3.53684 3.23077 6.31579 3.23077C9.09474 3.23077 11.3684 5.44615 11.3684 8.15385C11.3684 10.8615 9.09474 13.0769 6.31579 13.0769C3.53684 13.0769 1.26316 10.8615 1.26316 8.15385Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderSearch);
export default __webpack_public_path__ + "static/media/icon_header_search.ab480f1943de4ed9fc7d18c8d21e094d.svg";
export { ForwardRef as ReactComponent };